import React, {type PropsWithChildren} from 'react';
import {RemoteAccessEnvContext, type RemoteAccessEnv} from './env';

export function RemoteAccessEnvProvider({
  value,
  children,
}: PropsWithChildren<{value: RemoteAccessEnv}>) {
  return (
    <RemoteAccessEnvContext.Provider value={value}>
      {children}
    </RemoteAccessEnvContext.Provider>
  );
}
